import { useEffect } from 'react';

const ParallaxDots = () => {
  useEffect(() => {
    let rafId: number;
    const onScroll = () => {
      rafId = requestAnimationFrame(() => {
        const offset = window.scrollY * 0.3;
        document.body.style.setProperty('--dot-offset-y', `${offset}px`);
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      cancelAnimationFrame(rafId);
      document.body.style.removeProperty('--dot-offset-y');
    };
  }, []);
  return null;
};

export default ParallaxDots;
